import { render, staticRenderFns } from "./writeOweFeeCallable.vue?vue&type=template&id=35224e56"
import script from "./writeOweFeeCallable.vue?vue&type=script&lang=js"
export * from "./writeOweFeeCallable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports